function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 1.125C0 .78.317.5.709.5H16.29c.392 0 .709.277.709.625 0 .345-.317.625-.709.625H.71C.317 1.75 0 1.473 0 1.125zm0 4.333c0-.345.317-.625.709-.625H16.29c.392 0 .709.278.709.625 0 .346-.317.625-.709.625H.71C.317 6.083 0 5.806 0 5.458zm0 4.334c0-.346.317-.625.709-.625H16.29c.392 0 .709.277.709.625 0 .345-.317.625-.709.625H.71c-.392 0-.709-.278-.709-.625z",
  fill: "#CCCFD2",
  fillRule: "nonzero",
  opacity: 0.4
});

var SvgDrag = function SvgDrag(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11"
  }, props), _ref);
};

export default SvgDrag;